export const START_LOADER = '[Loader] START';
export const STOP_LOADER = '[Loader] STOP';
